import React from 'react'
import { Link, useNavigate, useLocation, Link as LinkNav } from "react-router-dom";
import { Link as ReactLink } from 'react-scroll';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../../Services/Firebase/firebaseConnection'

import { colorDetail, colorInteriorBack } from '../../styles/color'

import {
  Icon,
  Box,
  Flex,
  HStack,
  Image,
  Text,
  Button,
} from '@chakra-ui/react';


import logo from '../../Assets/Svg/logo.svg'

import { UserContext } from '../../Context/UserContext';

import { HiHome } from "react-icons/hi";
import { RiAdminLine, RiMoneyDollarCircleFill } from "react-icons/ri";
import { FaShoppingCart } from "react-icons/fa";
import { FaUser } from "react-icons/fa";

import PerfilPhoto from '../PerfilPhoto';
import BtnAdm from '../BtnAdm';


export function Header() {
  const { IsLogin, } = React.useContext(UserContext);
  const [isloged, setisloged] = React.useState(false)
  const navigate = useNavigate();
  const location = useLocation()

  React.useEffect(() => {

    async function checkLogin(){

      onAuthStateChanged(auth, (user) => {
        if(user){
          setisloged(true)
        }else{
          setisloged(false)
        }
      })
    }

    checkLogin();

  }, [])

  // cores do menu



  const NavLink = ({ children }) => (
    <ReactLink //tive que mudar para o link do react 
      to={children.link}
      smooth offset={-100} duration={600} delay={100}
    >
      <Flex align="center" _hover={{ color: "black" }} gap='1'>
        <Icon as={children.icon} />
        <Text cursor='pointer' fontFamily='Ubuntu Mono' textTransform='uppercase' fontSize={{ md: '11', lg: '14' }}>{children.nome}</Text>
      </Flex>
    </ReactLink>
  );

  return (
    <>
      {!IsLogin && (
        <Flex
          px={{ base: 4, lg: 8 }}
          bg={colorDetail}
          color="black"
          position="fixed"
          w="100%"
          top={{ base: null, md: '0' }}
          bottom={{ base: '0', md: null }}
          left="0"
          zIndex="999"
          h={{ base: '60px', md: '80px' }}
          boxShadow={{ base: "0 -4px 12px rgba(0,0,0,0.15)", md: "0 4px 12px rgba(0,0,0,0.15)" }}
          justifyContent="center"
          alignItems="center"
          borderTop={{ base: "1px solid rgba(255,255,255,0.2)", md: "none" }}
          borderBottom={{ base: "none", md: "1px solid rgba(255,255,255,0.2)" }}
        >
          <Flex maxW="1350px" w="100%" h="100%" alignItems="center" justifyContent={{ base: "center", md: "space-between" }} position="relative">

            {/* Desktop Logo */}
            <Flex display={{ base: 'none', md: 'flex' }}>
              <LinkNav to={'/'}>
                <Image src={logo} w="260px" transition="all 0.3s" _hover={{ transform: 'scale(1.02)' }} filter="drop-shadow(0px 2px 4px rgba(0,0,0,0.2))" />
              </LinkNav>
            </Flex>

            {/* Mobile Logo (Centered) */}
            <Flex display={{ base: 'flex', md: 'none' }} justify="center" align="center" w="100%">
              <LinkNav to={'/'}>
                <Image src={logo} w="160px" filter="drop-shadow(0px 2px 4px rgba(0,0,0,0.2))" />
              </LinkNav>
            </Flex>

            {/* ADM Button */}
            {isloged && (
              <Flex position="absolute" right={{ base: "0", md: "0" }}>
                <Button
                  size={{ base: "sm", md: "md" }}
                  leftIcon={<RiAdminLine size={16} />}
                  bg="blackAlpha.800"
                  color="white"
                  _hover={{ bg: "black", transform: "translateY(-1px)", boxShadow: "lg" }}
                  _active={{ bg: "blackAlpha.900" }}
                  borderRadius="full"
                  px={{ base: 4, md: 6 }}
                  boxShadow="md"
                  onClick={() => navigate('/admin')}
                  textTransform="uppercase"
                  fontSize={{ base: "10px", md: "12px" }}
                  fontWeight="bold"
                  letterSpacing="1px"
                >
                  Admin
                </Button>
              </Flex>
            )}
          </Flex>
        </Flex>
      )}
    </>
  );
}

export default Header